// 数据处理相关常量
export const SPAN_THRESHOLD_RATIO = 0.6; // 跨度阈值比例，用于判断直方图分布的连续性

// 区域阈值常量
export const ZONE_THRESHOLDS = {
    BLACKS: 24,       // 暗部阈值 (0-24)
    SHADOWS: 84,      // 阴影阈值 (25-84)
    MIDTONES: 170,    // 中间调阈值 (85-170)
    HIGHLIGHTS: 230,  // 高光阈值 (171-230)
    WHITES: 231       // 亮部起始阈值 (231-255)
};

export const ZONE_TYPES = {
    BLACKS: 'blacks',
    SHADOWS: 'shadows',
    MIDTONES: 'midtones',
    HIGHLIGHTS: 'highlights',
    WHITES: 'whites'
};

// 直方图分析默认配置
export const DEFAULT_HISTOGRAM_OPTIONS = {
    thresholdPercentage: 0.05,  // 直方图截断阈值，防止极值影响
    steps: 10,                 // 分档数量，将256个值分为10个区间
    spanThresholdRatio: 0.7,   // 跨度判定比例，用于确定分布的连续性
    blacksThreshold: ZONE_THRESHOLDS.BLACKS,
    shadowsThreshold: ZONE_THRESHOLDS.SHADOWS,
    midtonesThreshold: ZONE_THRESHOLDS.MIDTONES,
    highlightsThreshold: ZONE_THRESHOLDS.HIGHLIGHTS,
    whitesThreshold: ZONE_THRESHOLDS.WHITES,
    clippingShadowThreshold: 1,
    clippingHighlightThreshold: 254,
    nearClippingShadowThreshold: 3,
    nearClippingHighlightThreshold: 252,
    hardClippingRatioThreshold: 0.001,
    nearClippingRatioThreshold: 0.001,
    bins: 256,
    range: [0, 255]
};

// HSL 统计配置
export const HSL_ANALYSIS_OPTIONS = {
    // Hue 统计/掩膜/点测统一有效性门槛（0~1）
    // 仅当 S、L、delta(max-min) 同时满足阈值时，才认为 Hue 有效
    validHueSaturationMin: 0.1,
    validHueLightnessMin: 0.03,
    validHueDeltaMin: 0.03
};

// 通道类型
export const CHANNEL_TYPES = {
    RGB: 'RGB',
    RED: 'R',
    GREEN: 'G',
    BLUE: 'B',
    UNKNOWN: 'unknown'
};

// 分析类型
export const ANALYSIS_TYPES = {
    ORIGINAL: 'original',
    PROCESSED: 'processed'
};

// Worker消息类型
export const MESSAGE_TYPES = {
    // Worker 生命周期 / 预加载协议（与 workerManager、AnalysisProcessor、analysisWorker 共用，避免裸字符串各写各的导致漂移）
    PING: 'ping',
    PONG: 'pong',
    PRELOAD: 'preload',
    OPENCV_READY: 'opencv_ready',
    OPENCV_ERROR: 'opencv_error',
    PARTIAL: 'partial',
    COMPLETE: 'complete',
    ERROR: 'error',
    PROCESSED_IMAGE: 'processedImage',
    BORDER_INFO: 'borderInfo',
    ANALYSIS_PHASE_COMPLETE: 'analysisPhaseComplete',
    ANALYSIS_RESULTS: 'analysisResults',
    GRAYSCALE_DATA: 'grayscaleData',
    LAB_STATISTICS: 'labStatistics',
    LAB_STATISTICS_ERROR: 'labStatisticsError',
    HSL_STATISTICS: 'hslStatistics',
    HSL_STATISTICS_ERROR: 'hslStatisticsError',
    LAB_DETAILED_ANALYSIS: 'labDetailedAnalysis',
    HSL_DETAILED_ANALYSIS: 'hslDetailedAnalysis',
    HSL_DETAILED_ANALYSIS_ERROR: 'hslDetailedAnalysisError',
    COLOR_PALETTE: 'colorPalette',
    COLOR_PALETTE_ERROR: 'colorPaletteError'
};

// 掩膜相关常量
export const MASK_TYPES = {
    BINARY: 'binary',
    ZONE: 'zone',
    CHANNEL: 'channel'
};
